module.exports = __webpack_public_path__ + "static/media/about-20.32a377b1.png";